// @flow

import React from 'react';
export function AppIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 17C3.89543 17 3 16.1046 3 15L3 11L9 11L9 17L5 17Z" fill="#5C5F62" />
      <path d="M11 17L11 11L17 11L17 15C17 16.1046 16.1046 17 15 17L11 17Z" fill="#5C5F62" />
      <path d="M3 5L3 9L9 9L9 3L5 3C3.89543 3 3 3.89543 3 5Z" fill="#5C5F62" />
      <path
        d="M11 6C11 5.44771 11.4477 5 12 5L13 5L13 4C13 3.44771 13.4477 3 14 3C14.5523 3 15 3.44772 15 4L15 5L16 5C16.5523 5 17 5.44771 17 6C17 6.55228 16.5523 7 16 7L15 7L15 8C15 8.55228 14.5523 9 14 9C13.4477 9 13 8.55228 13 8L13 7L12 7C11.4477 7 11 6.55228 11 6Z"
        fill="#5C5F62"
      />
    </svg>
  );
}
